import React from 'react';
import { Component, Position, Container } from "puzzle";
import SourceFiles from "../../Content/SourceFiles/SourceFiles";
import { checkFilesEquality } from "../Utility"
import _ from "lodash";
import { DEFAULT_PROPS, PROPS, STATE } from "./Types"

class ContentPopup extends Component<STATE, PROPS> {

  static defaultProps: DEFAULT_PROPS = {
    dispatcherUpdateStates: {
      uploadFlowState: {}
    }
  };

  state = {
    uploadFlowState: {}
  };

  componentDidUpdate(prevProps: PROPS, prevState: STATE) {
    const { uploadFlowState } = prevState;
    const { uploadFlowState: currentUploadFlowState } = this.state;

    if (!_.isEqual(currentUploadFlowState, uploadFlowState)) {

      const fileUploadInProgress = !this.isAllUploadEnd();
      if (this.isModuleMounted) {
        this.dispatch('updateContentPopupDialog', {
          pos: Position.start,
          persistent: ['uploadIsInProgress']
        }, {
          uploadIsInProgress: fileUploadInProgress
        })
      }
    }
  };


  /**
   * Change flag so progress bar wont get rendered
   */
  addUploadedFlag = (files: any) => {
    return files.map((item: any) => {
      item.isAlreadyUpload = true;
      return item;
    })
  };

  /**
   * Checks is there is any changes in received and current data
   * @param filesBeforeOpen
   * @param currentFiles
   */
  hasDataChange = (filesBeforeOpen: any[], currentFiles: any[]) => {
    return !checkFilesEquality(filesBeforeOpen, currentFiles);
  };

  renderBody() {
    const {
      isTemplate = false,
      submissionStatus,
      partiallyAnalyzed,
      projectFileFormats,
      batchInfos,
      submissionId,
      submissionStarted
    } = this.props.contentProps;

    const { project } = this.props.contentProps.form.getFields();

    return (
      <Container
        ariaLabel={this.translate('SRL-section')}
        displayFlex
        className={'tp-section-container tp-content-section'}
        htmlTag={'section'}
        tabIndex={0}
      >
        <div className={'tp-section-container-content-inner-wrap'}>
          <SourceFiles
            batch={batchInfos[0]}
            deleteOnSave={true}
            isDisabled={isTemplate}
            moduleId={'fromContentPopUp'}
            partiallyAnalyzed={partiallyAnalyzed}
            projectFileFormats={projectFileFormats}
            projectId={project?.value}
            selectionField={'selected'}
            submissionId={submissionId}
            submissionStarted={submissionStarted}
            submissionStatus={submissionStatus}
            uploadFlowState={this.state.uploadFlowState}
          />
        </div>
      </Container>
    );
  }
}

export default ContentPopup;
